// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-tree-expand-button {
  border-radius: 2px;
  margin-right: 4px;
  padding: 6px;
}

.bolt-tree-expand-button:hover {
  background-color: rgba( 234, 234, 234 ,  1 );
  background-color: rgba( var(--palette-neutral-8,234, 234, 234) ,  1 );
}

@media (forced-colors: active) {
  .bolt-tree-expand-button:not(.disabled):hover {
    color: HighLight;
  }
}

/*# sourceMappingURL=TreeExpand.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/TreeEx/TreeExpand.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/TreeEx/TreeExpand.css"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,iBCkTQ;EDjTR,YAAA;AEAJ;;AFGA;EACI,4CCwEQ;ECxEV,qEAAqE;AACvE;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,yCAAyC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
